<template>
  <div class="main-body">
    <nav
      class="navbar navbar-vertical fixed-right navbar-expand-md navbar-light"
      id="sidenav-main"
      background-color="vue"
      short-title="Dariush"
      title="Dariush"
    >
      <div class="container-fluid">
        <button
          @click="
            opened = !opened;
            closeMenu();
          "
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <router-link to="/" class="header-logo d-md-none"
         
         >
         <img src="/img/logo-lighten.png"/>
         </router-link>

        <ul class="nav align-items-center d-md-none">
          <!-- <li class="dropdown dropdown nav-item" aria-haspopup="true" aria-expanded="false">
            <a class="nav-link nav-link-icon" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false"><i class="ni ni-bell-55"></i></a>
            <ul class="dropdown-menu dropdown-menu-right">
              <a class="dropdown-item" href="#">Action</a><a class="dropdown-item" href="#">Another action</a>

              <a class="dropdown-item" href="#">Something else here</a>
            </ul>
          </li> -->
          <li
            class="dropdown dropdown nav-item"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <a
              @click="isOpen = !isOpen"
              class="nav-link"
              href="#"
              role="button"
            >
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle"
                  ><img alt="Image placeholder" src="/img/avatarnu.png"
                /></span>
              </div>
            </a>

            <ul class="dropdown-menu dropdown-menu-right">
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">خوش آمدید!</h6>
              </div>
              <a href="#/profile" class="dropdown-item"
                ><i class="ni ni-single-02"></i><span>My profile</span></a
              ><a href="#/profile" class="dropdown-item"
                ><i class="ni ni-settings-gear-65"></i><span>Settings</span></a
              ><a href="#/profile" class="dropdown-item"
                ><i class="ni ni-calendar-grid-58"></i><span>Activity</span></a
              ><a href="#/profile" class="dropdown-item"
                ><i class="ni ni-support-16"></i><span>Support</span></a
              >
              <a href="#!" class="dropdown-item"
                ><i class="ni ni-user-run"></i><span>Logout</span></a
              >
            </ul>
          </li>
        </ul>
        <div
          class="navbar-collapse collapse show"
          id="sidenav-collapse-main"
          style="display: none"
        >
          <div class="navbar-collapse-header d-md-none">
            <div class="row">
              <div class="col-6 collapse-brand">
                <a href="#/" class="active"
                  ><img src="img/brand/logo-pardis.png"
                /></a>
              </div>
              <div class="col-6 collapse-close">
                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span></span><span></span>
                </button>
              </div>
            </div>
          </div>
          <div class="side-menu">
            <ul class="navbar-nav">
              <li class="nav-item" v-for="menu in menuList" :key="menu.id">
                <router-link
                  class="router-link-exact-active nav-link"
                  aria-current="page" 
                  :to="menu.path"
                >
                  <span> <i :class="menu.icon"></i> {{ menu.title }} </span>
                </router-link>
              </li>
            </ul>
            <ul class="nav nav-footer">
              <li class="nav-item">
                <a title="تماس مستقیم " href="tel://02144631360" id="phone" dir="auto">
                  021-44631360-5
                </a>
              </li>

              <li class="nav-item">
                <!-- <span>09045425792</span> -->
                <a title="ارسال پیام با واتس اپ" href="https://wa.me/+989045425792" target="_blank"
                >
                <img
                  class="whatsapp-icon"
                  src="/img/WhatsApp_icon.png"
                  alt=""
                />
                09045425792</a
                >
              </li>
            </ul>
          </div>
          <!-- <router-link
            to="/profile/dashboard"
            v-if="this.$route.fullPath.includes('club')"
            class="dropdown-item special-side-button"
            ><i _ngcontent-c3="" class="icon-users-3"></i
            ><span _ngcontent-c3=""> پروفایل </span>
          </router-link>

          <router-link
            to="/club/dashboard"
            v-if="this.$route.fullPath.includes('profile')"
            class="dropdown-item special-side-button"
            ><i _ngcontent-c3="" class="icon-chart-pie-3"></i
            ><span _ngcontent-c3="">باشگاه مشتریان </span>
          </router-link> -->
        </div>
      </div>
    </nav>
    <Transition name="fade">
      <ul
        v-if="opened === true"
        class="navbar-nav d-block d-sm-none box-sidebar-mobile"
      >
        <li @click="close" class="style-close">
          <i class="icon-cancel-1"></i>
        </li>
        <li
          @click="close"
          class="nav-item"
          v-for="menu in menuList"
          :key="menu.id"
        >
          <router-link
            class="router-link-exact-active nav-link"
            aria-current="page"
            :to="menu.path">
            <i :class="menu.icon"></i>

            <span>
              {{ menu.title }}
            </span>
          </router-link>
        </li>
      </ul>
    </Transition>
    <Transition name="menu">
      <div class="panel-use" v-if="isOpen">
        <div _ngcontent-c3="">
          <div class="">
            <span style="margin-right: 1px" class="text-overflow text-danger"
              >خوش آمدید!</span
            >
            <div style="text-align: end; margin-top: -30px">
              <i @click="closeMenu" class="icon-cancel-1"></i>
            </div>
          </div>

          <div
            _ngcontent-c3=""
            class="dropdown-item"
            routerlinkactive="active"
            href="#/user-profile"
          >
            <i _ngcontent-c3="" class="icon-money-1"></i
            ><span _ngcontent-c3="">
              اعتبار شما : {{ GetSumDeposit | numFormat }}</span
            >
          </div>
          <div
            _ngcontent-c3=""
            class="dropdown-item"
            routerlinkactive="active"
            href="#/user-profile"
          >
            <i _ngcontent-c3="" class="icon-award"></i
            ><span _ngcontent-c3="">
              امتیاز شما : {{ GetCustomerScore | numFormat }}</span
            >
          </div>
          <div
            _ngcontent-c3=""
            class="dropdown-item"
            routerlinkactive="active"
            href="#/user-profile"
          >
            <i _ngcontent-c3="" class="icon-money-2"></i
            ><span _ngcontent-c3="">
              اعتبار ریالی :
              {{ GetCustomerValueAmount | numFormat }}</span
            >
          </div>
          <router-link
            to="/profile/dashboard"
            v-if="this.$route.fullPath.includes('club')"
            class="dropdown-item"
            ><i _ngcontent-c3="" class="icon_set_1_icon-81"></i
            ><span _ngcontent-c3=""> پروفایل </span>
          </router-link>

          <router-link
            to="/club/dashboard"
            v-if="this.$route.fullPath.includes('profile')"
            class="dropdown-item"
            ><i _ngcontent-c3="" class="icon_set_1_icon-81"></i
            ><span _ngcontent-c3="">باشگاه مشتریان </span>
          </router-link>

          <div _ngcontent-c3="" class="dropdown-divider"></div>
          <a _ngcontent-c3="" class="dropdown-item" @click="SignOut()"
            ><i _ngcontent-c3="" class="ni ni-user-run"></i
            ><span _ngcontent-c3="">خروج</span></a
          >
        </div>
      </div>
    </Transition>
    <div class="left-body">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menuList: { type: Array, default: [] },
    modalTitle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      opened: false,
      activeSelected: 0,
    };
  },
  computed: {
    GetSumDeposit() {
      // debugger;
      if (localStorage.getItem("SourceIdInReport") != null)
        return this.$store.getters.GetSumDeposit;
      else return 0;
    },
  },
  methods: {
    close() {
      this.opened = false;
    },
    closeMenu() {
      this.isOpen = false;
    },
    // clickSide(selected) {
    //   this.activeSelected = selected;
    //   console.log(selected, "selected");
    // },
  },
  // created() {
  //   //find locl storage size
  //   var _lsTotal = 0,
  //     _xLen,
  //     _x;
  //   for (_x in localStorage) {
  //     if (!localStorage.hasOwnProperty(_x)) {
  //       continue;
  //     }
  //     _xLen = (localStorage[_x].length + _x.length) * 2;
  //     _lsTotal += _xLen;
  //     console.log(_x.substr(0, 50) + " = " + (_xLen / 1024).toFixed(2) + " KB");
  //   }
  //   console.log("Total = " + (_lsTotal / 1024).toFixed(2) + " KB");
  // },
};
</script>
<style scoped>
.style-close {
  text-align: left;
}

.icon-cancel-1 {
  font-size: 30px;
}

.panel-use {
  background-color: #ffffff;
  width: 98%;
  position: absolute;
  left: 1%;
  z-index: 99;
  justify-content: end;
  padding: 20px;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 20%);
  -webkit-box-shadow: 0 0 15px 0 rgb(0 0 0 / 20%);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
}
.side-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  flex: 1;
  padding-bottom: 100px;
}
.side-menu a {
  color: #fff;
}
.side-menu .whatsapp-icon {
  width: 33px;
  margin-left: 8px;
}
.side-menu a#phone:before {
  font-size: 18px;
  right: 0;
  top: -4px;
  padding: 2px 6px;
  max-width: 30px;
  background: #fff;
  border-radius: 100%;
  color: #333;
}
.panel-use .dropdown-item {
  padding: 10px 15px 3px;
}

.panel-use .dropdown-item i {
  font-size: 20px;
  vertical-align: sub;
  color: #3f87d7;
}

.panel-use .dropdown-item:last-child i {
  margin-left: 8px;
}

.panel-use h6 {
  color: #e23;
  font-size: 13px;
  padding-bottom: 15px;
}

.text-sidebar-mobile {
  /* padding: 37px; */
  padding-right: 10px;
  padding-left: 40px;
}

.text-sidebar-mobile small {
  font-size: 15px;
}

.text-sidebar-mobile i {
  font-size: 20px;
}

.box-sidebar-mobile {
  background: rgb(255 255 255 / 97%) !important;
}

.header-logo {
  flex: 1 1;
}

.header-logo img {
  width: 100%;
}

ul.navbar-nav.d-block.d-sm-none {
  padding: 10px;
  z-index: 10;
  box-shadow: 0 0 170px #202020;
  position: fixed;
  color: #000;
  background-color: #f1f1f1;
  right: 3%;
  top: 1vh;
  width: 94%;
  height: 94vh;
  border-radius: 10px;
}

ul.navbar-nav.d-block.d-sm-none li {
  float: none;
}
.navbar-collapse .special-side-button {
  margin-top: 110px;
  text-align: center !important;
  border: 1px solid #fcbe2f;
  padding: 9px;
  border-radius: 30px;
  font-weight: bold;
  font-size: 15px;
  color: #ffffff;
}
.navbar-collapse .special-side-button:hover,
.navbar-collapse .special-side-button:focus {
  background-color: #fcbe2f;
  color: #172b4d;
}
.navbar-collapse .special-side-button i {
  margin-left: 5px;
  font-size: 17px;
  vertical-align: top;
}
.text-primary {
  color: #fff !important;
}

.navbar-nav li.nav-item a span i {
  float: right;
  margin-left: 15px;
  font-size: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: transform 0.4s, opacity 0.45s;
  transform: translateX(50);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.5s ease;
}

.menu-enter-from,
.menu-leave-to {
  opacity: 0;
}

.router-link-active {
  position: relative;
}
.router-link-active span {
  color: #fcbe2f !important;
}
.router-link-active span i {
  color: #fcbe2f !important;
}
.router-link-active:before {
  content: " ";
  top: 0.25rem;
  bottom: 0.25rem;
  right: 0;
  left: auto;
  width: 4px;
  height: 70%;
  top: 15%;
  background: #fcbe2f;
  border-radius: 30px;
  position: absolute;
}
</style>